import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TypeWebhook } from 'src/api/models';

@Component({
  selector: 'app-webhook-type-select',
  templateUrl: './webhook-type-select.component.html',
  styleUrls: ['./webhook-type-select.component.css']
})
export class WebhookTypeSelectComponent implements OnInit {

  @Input('id') public id: number;
  @Output() idChange = new EventEmitter<number>();

  @Input() cell: any;

  webhookTypes = [];

  constructor() { 
    for (var t in TypeWebhook) {
      let value = parseInt(t, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.webhookTypes.push({ id: value, name: TypeWebhook[t]});
      }
    }      
  }

  ngOnInit(): void {
  }

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  }  
}
